<template>
  <div>
      <b-form-group label="Ihre Anmerkung zur Bestellung (Bitte geben Sie hier weitere Anmerkungen wie z. B. betreuende Person an.)" label-for="order-comment">
        <b-form-textarea id="order-comment" v-model="CHECKOUT_DATA.comment"></b-form-textarea>
      </b-form-group>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {
  BFormGroup,
  BFormTextarea
} from "bootstrap-vue";

export default {
  name: "CommentSection",
  components: {
    BFormTextarea,
    BFormGroup
  },
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters(['SERVICE', 'CHECKOUT_DATA']),
  },
  methods: {
    formatPrice(price) {
      return new Intl.NumberFormat('de-DE', {style: 'currency', currency: 'EUR'}).format(price / 100)
    },
  }
}
</script>

<style scoped>

</style>
